var React = require('react');

function Engine (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M14.005 19.66l2.06 1.269a2.504 2.504 0 0 1 1.358-1.686l-1.552-1.798a3.51 3.51 0 0 1-1.866 2.216zm-2.59.169A3.502 3.502 0 0 1 12.5 13c1.305 0 2.443.714 3.045 1.773l3.767 4.362a2.5 2.5 0 1 1-2.868 3.789l-5.028-3.095zM4.51 22H3v1a1 1 0 0 1-2 0V13a1 1 0 0 1 2 0v1h1.556l.002-.463a1.5 1.5 0 0 1 .433-1.045l3.496-3.545A1.5 1.5 0 0 1 9.555 8.5H11V7H9a1 1 0 1 1 0-2h12a1 1 0 0 1 0 2h-2v1.5h3.5A1.5 1.5 0 0 1 24 10v2.045h3V10a1 1 0 0 1 2 0v18a1 1 0 0 1-2 0v-2.343h-3V27a1.5 1.5 0 0 1-1.5 1.5H9.213a1.5 1.5 0 0 1-1.068-.447l-3.213-3.257a1.5 1.5 0 0 1-.432-1.062L4.51 22zm3.045-7.836l-.051 8.967L9.84 25.5H21v-1.343a1.5 1.5 0 0 1 1.5-1.5h3v-7.612h-3a1.5 1.5 0 0 1-1.5-1.5V11.5H10.183l-2.628 2.664zM14 16.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm5 5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0z"}));
}

Engine.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Engine;

Engine.default = Engine;
